import {ApiRequest, RequestMethod} from "../../../request";

export async function deleteTrait(id: string): Promise<boolean> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.DELETE);
    apiRequest.setUrl(`/api/weapon-trait/${id}`);

    const response: any = await apiRequest.send();

    return response.status === 200;
}